import Card from '/public/icons/card.svg?react';
import Add from '/public/icons/add.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
//import { Button } from '~/shared/ui/Button/Button';
import {
  cvaAddingCard,
  cvaAddingCardText,
} from '~/features/AddingCard/AddingCardStyles';
import { FC, useEffect, useState } from 'react';
import { useAddCard } from '~/shared/hooks/useAddCard';
import { LoadingSpinner } from '~/shared/ui/LoadingSpinner/LoadingSpinner';
import { useGetPaymentInfo } from '~/shared/hooks/useGetPaymentInfo';
import { useGetCards } from '~/shared/hooks/useGetCards';
// import { Link } from '@remix-run/react';
//import { PaymentWidget } from '~/widgets/Payment/ui/PaymentWidget/PaymentWidget';
import { Portal } from '~/shared/ui/Portal/Portal';
import { Popup } from '~/entities/Popup/Popup';

interface Props {
  text: string;
  type?: 'primary' | 'secondary';
}

export const AddingCard: FC<Props> = ({ text, type }) => {
  const [id, setId] = useState<string | null>(null);

  const [isError, setIsError] = useState<null | string>(null);

  const { paymentInfo } = useGetPaymentInfo(id);
  const { refetch } = useGetCards();

  const onSuccess = (res: { id: string }) => {
    setId(res.id);
  };

  useEffect(() => {
    if (paymentInfo?.status === 'paid') {
      refetch();
    }
  }, [paymentInfo?.status]);

  const { addCard, isLoading } = useAddCard(onSuccess);

  return (
    <>
      <div
        className={cvaAddingCard({ type })}
        onClick={() => {
          addCard();
        }}>
        <div className={cvaAddingCardText()}>
          <Card className={cvaIcon({ iconSize: 'third' })} />
          <span>{text}</span>
        </div>
        {isLoading ? (
          <LoadingSpinner size={'small'} className="absolute -right-0.2" />
        ) : (
          <Add className={cvaIcon({ iconSize: 'common' })} />
        )}
      </div>
      {/* {openPaymentWidget && url?.length ? (
        <Portal>
          <PaymentWidget
            title="Добавление карты"
            url={url}
            setIsError={(message) => setIsError(message)}
            setIsSuccess={() => {}}
            onClose={() => {
              refetch();
              setOpenPaymentWidget(false);
            }}
          />
        </Portal>
      ) : null} */}
      {isError && isError?.length ? (
        <Portal>
          <Popup
            formPopup
            title="Ошибка оплаты"
            image="/images/card-error.png"
            description={isError}
            button={{
              text: 'Повторить',
              isLoading: isLoading,
              action: () => {
                addCard();
                setIsError('');
              },
            }}
            button_second={{ text: 'Закрыть', action: () => setIsError('') }}
            open
          />
        </Portal>
      ) : null}
    </>
  );
};
